<template>
  <div>
    <div class="page-content">
      <div class="container-fluid background">
        <div class="row">
          <img src="~@/assets/images/sunset.jpg" alt="Sunset" class="col-12 p-0">
        </div>
      </div>
      <div class="container content">
        <div class="row">
          <div class="col-12">
            <h1 class="page-header">
              Voices of the Bereaved
              <hr />
            </h1>
          </div>
          <div class="col-12 page-content-inner">

            <p>
              <strong>
              ‘”Talking to people who had lost a loved one in similar circumstances helped me to understand I wasn’t alone.”  Anon
              </strong>
            </p>

            <p>
              <strong>
              “What a breath of fresh air to be able to express anything about being touched by suicide in a safe, understanding, supportive, friendly, kind environment, in the comfort of a home.  It’s a life changer.”  Adele B
              </strong>
            </p>

            <p>
              <strong>
              “This support group was my beacon of hope in those early dark days, it showed me that I’m not alone, that there is life after suicide loss and how to sit with that sadness. I can confidently say that I wouldn't be where I am today without it."  Kirsty
              </strong>
            </p>

            <p>
              <strong>
              “I go over details again and again in my mind but I have questions that can never be answered.”  Anon
              </strong>
            </p>

            <p>
              <strong>
              “I was feeling at a very low ebb, having lost my beloved daughter to suicide when, like a miracle, I received a letter through the post containing details of the suicide bereavement support group.  It felt like a lifeline. Being bereaved by suicide is a very isolating and lonely place to be, but sharing our grief with one another in the group helps more than I can say.”  Alexandra
              </strong>
            </p>

            <p>
              Feelings of isolation, guilt and anger with a need for the nature of one’s grief to be understood by others, may all be experienced following the loss of someone who has taken their own life.
            </p>
            <p>
              We are an independent, Norwich based, community group that provides support for people who have been bereaved or affected by suicide.
            </p>

            <p>
              The group is led by volunteers with lived experience of personal loss through suicide and appreciation of the compassionate care and support that is needed for those who are grieving.
            </p>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'voices-of-the-bereaved'
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

/****************************
    BANNER
*****************************/
.background {
  margin-top: -64px;
  width: 100%;
  height: 430px;
  border-bottom: 3px solid $primary;

  @media screen and (max-width: $md-breakpoint) {
    height: 300px;
  }

  .row {
    height: 100%;
  }

  .row img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/****************************
    CONTENT
*****************************/
.content {
  margin-top: 64px;
  h2 {
    font-size: 28px;
    @media (max-width: $md-breakpoint) {
      font-size: 22px !important;
      }
  }
}

.page-content-inner hr {
  margin-bottom: 10px;
  margin-top: 10px;
  width: 50px;
}

/****************************
    ABOUT US
*****************************/
.about-us {
  &-img {
    border-radius: 0.3rem;
    border: 3px solid $primary;
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: baseline;
  }
}

/****************************
    GET IN TOUCH CTA
*****************************/
.cta-banner {
  background-color: $primary;
  padding: 30px 0;

  &-wrapper {
    display: flex;
    align-items: center;

    &:last-child {
      justify-content: flex-end;

      @media (max-width: $lg-breakpoint) {
        justify-content: center;
      }

      @media (max-width: $md-breakpoint) {
        justify-content: flex-start;
      }
    }
  }

  &-title {
    font-size: 40px;
    font-weight: 500;
    color: $white;
  }

  &-content {
    margin: 0;
    font-size: 18px;
    color: $white;
  }

  &-btn {
    background-color: $primary-dark;

    &:hover {
      background-color: $white;
      color: $primary;
    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/pages/Voices.vue